import { POSITION_FILTER } from '../actions/types';

export default function(state = false, action) {
  switch (action.type) {
    case POSITION_FILTER:
      const positionFilter = action.payload === 'false' ? false : action.payload;
      return positionFilter || false;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/positionFilterReducer.js